import ProductsList, { ProductListTypes } from 'components/Blocks/Product/List/ProductsList';
import UserText from 'components/Helpers/UserText/UserText';
import { BlogPaymentsList } from 'components/Pages/BlogArticle/BlogFulfillmentList/BlogPaymentList';
import { BlogTransportsList } from 'components/Pages/BlogArticle/BlogFulfillmentList/BlogTransportsList';
import { GJS_PRODUCTS_SEPARATOR } from 'config/constants';
import { useProductsByCatnums } from 'connectors/products/Products';
import { useGtmProductListView } from 'hooks/gtm/useGtmProductListView';
import { memo, useRef } from 'react';
import { GtmListNameType } from 'types/gtm';
import { ListedProductType } from 'types/product';
import { parseCatnums } from 'utils/grapesJsParser';

type GrapeJsParserProps = {
    text: string;
    gtmListName: GtmListNameType;
    uuid: string;
};

const GrapeJsParser: FC<GrapeJsParserProps> = ({ text, gtmListName, uuid }) => {
    const productListInstancesCountRef = useRef(0);
    const productsCatnum = parseCatnums(text);
    const allProducts = useProductsByCatnums(productsCatnum);
    const dividedParts = text.split(GJS_PRODUCTS_SEPARATOR).filter(Boolean);

    const RenderArticleProductList = (part: string, index: number) => {
        const instanceNumber = useGtmProductListView(allProducts, gtmListName, productListInstancesCountRef);

        if (allProducts === null) {
            return (
                <ProductsList
                    key={`${uuid}productList${index}`}
                    inArticle
                    isLoading
                    gtmListName={`${gtmListName} ${instanceNumber}`}
                    products={[]}
                    type={ProductListTypes.Normal}
                    underline={false}
                />
            );
        }

        const products = parseCatnums(part)
            .map((product) => allProducts.find((blogArticleProduct) => blogArticleProduct.catalogNumber === product))
            .filter(Boolean) as ListedProductType[];

        return (
            <ProductsList
                key={`${uuid}productList${index}`}
                inArticle
                gtmListName={`${gtmListName} ${instanceNumber}`}
                products={products}
                type={ProductListTypes.Normal}
                underline={false}
            />
        );
    };

    const renderGrapesJsParts = (part: string, index: number) => {
        const partKey = `${uuid}-part-${part.slice(0, 50)}`;

        if (part.match(/\[gjc-comp-FulfillmentList&#61;payment\]/g)) {
            return <BlogPaymentsList key={partKey} />;
        }

        if (part.match(/\[gjc-comp-FulfillmentList&#61;shipping\]/g)) {
            return <BlogTransportsList key={partKey} />;
        }

        if (part.match(/\[gjc-comp-(.*?)\]/g)) {
            return RenderArticleProductList(part, index);
        }

        return <UserText key={partKey} isGrapesJs htmlContent={part} />;
    };

    return (
        <div className="[&>*:last-child_*:last-child]:mb-0">
            {dividedParts.map((part, index) => renderGrapesJsParts(part, index))}
        </div>
    );
};

export default memo(GrapeJsParser);
